import {
  MenuButton,
  Menu,
  MenuItem,
  MenuList,
  Grid,
  GridItem,
  Heading,
  Text,
  Button,
  useDisclosure,
  Box
} from "@chakra-ui/react";
import { IoMdAdd } from '@react-icons/all-files/io/IoMdAdd';
import { useLoggedinUser, usePacks, useToastNotification } from "lib/hooks";
import { packsClient } from "lib/clients";
import { useRouter } from "next/router";
import { PacksIcon } from "lib/icons/packs";
import { useE2EEContext } from "lib/e2ee";
import { RiShieldKeyholeLine } from '@react-icons/all-files/ri/RiShieldKeyholeLine';
import { CreatePassword, EnterPassword } from "domains/pack";
import { Modal } from "components";
import { createEncryptedPack } from "lib/utils";

export const CreatePackButton = () => {
  const { errorToast } = useToastNotification();
  const { push } = useRouter();
  const { mutate } = usePacks();
  const { data: user } = useLoggedinUser();
  const create = useDisclosure();
  const login = useDisclosure();
  const { keys, enableEncryptedPacks } = useE2EEContext();

  const onCreatePack = async () => {
    try {
      const {data: newPack} = await packsClient.createPack({ title: 'Untitled Pack' });
      await mutate();
      return push(`/packs/${newPack.id}`)
    } catch (err) {
      console.log(err);
      errorToast({ title: 'Error', description: 'Could not create pack' });
    }
  }

  const onCreateEncryptedPack = async (keys: any) => {
    try {
      const newPack = await createEncryptedPack('Untitled Pack', keys);

      await mutate();
      return push(`/packs/${newPack.id}`)
    } catch (err) {
      console.log(err)
      errorToast({ title: 'Error', description: 'Could not create pack' });
    }
  }

  let handleCreateEncryptedPack = () => onCreateEncryptedPack(keys) as any;

  if (!user?.has_password) {
    handleCreateEncryptedPack = create.onOpen;
  }
  else if (!user?.private_key_armored || !user?.public_key_armored) {
    handleCreateEncryptedPack = login.onOpen;
  }

  const onComplete = async (user: any) => {
    if (create.isOpen) create.onClose();
    if (login.isOpen) login.onClose();

    const keys = {
      id: user.key_id,
      public: user.publicKey
    }

    onCreateEncryptedPack(keys);
  }

  if (enableEncryptedPacks) {
    return (
      <>
        <Menu>
          <MenuButton
            as={Button}
            aria-label='Create Pack Options'
            leftIcon={<IoMdAdd/>}
            variant='primary'
            iconSpacing={1}
            fontSize={["xs", "sm"]}
            size={"sm"}
          >
            Create
          </MenuButton>
          <MenuList>
            <MenuItem padding={'15px 20px'} onClick={onCreatePack}>
              <Grid
                maxWidth={"225px"}
                templateColumns={"32px auto"}
                gap={"27px"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <GridItem>
                  <PacksIcon boxSize={"32px"}/>
                </GridItem>
                <Grid templateRows={"auto auto"} gap={1}>
                  <Heading size={"xs"}>Create a Pack</Heading>
                  <Text variant={"secondary"} size={"xs"}>Perfect for sharing files that aren’t sensitive in nature.</Text>
                </Grid>
              </Grid>
            </MenuItem>
            <MenuItem padding={'15px 20px'} onClick={handleCreateEncryptedPack}>
              <Grid
                maxWidth={"225px"}
                templateColumns={"32px auto"}
                gap={"27px"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <GridItem>
                  <RiShieldKeyholeLine size={32} color="#06BCC1" />
                </GridItem>
                <Grid templateRows={"auto auto"} gap={1}>
                  <Heading size={"xs"}>Create Encrypted Pack</Heading>
                  <Text variant={"secondary"} size={"xs"}>Advanced security settings, ideal for sensitive information.</Text>
                </Grid>
              </Grid>
            </MenuItem>
          </MenuList>
        </Menu>
        <Modal title="Create password" isOpen={create.isOpen} onClose={create.onClose}>
          <Box padding="0 20px 20px">
            <CreatePassword onComplete={onComplete} />
          </Box>
        </Modal>
        <Modal title="Enter password" isOpen={login.isOpen} onClose={login.onClose}>
          <Box padding="0 20px 20px">
            <EnterPassword onComplete={onComplete} />
          </Box>
        </Modal>
      </>
    )
  }

  return (
    <Button
      aria-label='Create Pack'
      leftIcon={<IoMdAdd/>}
      variant='primary'
      iconSpacing={1}
      fontSize={["xs", "sm"]}
      size={"sm"}
      onClick={onCreatePack}
    >
      Create
    </Button>
  )
}
